import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import { Spinner } from '@creditflowresearch/uilib/Loader/Spinner';
import { TrancheList } from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList';
import { columns } from '@/creditflowresearch/ui/components/deals/DealListTable/columns/CorporateDealPageColumns';
import DealDetails from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/DealDetails';
import CorporateDataTable from '@/creditflowresearch/ui/components/deals/DealListTable/components/CorporateDataTable';
import type { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';

export const CorporateDealsPageTable = () => {
  const { deal, isFetching } = useDealPageContext();

  return (
    <>
      <CorporateDataTable
        columns={ columns }
        data={ [deal as ICorporateDeal] }
        className={ dataTableStyles.isHoverable }
        isFetching={ isFetching }
        dataTest="dealsList"
        loadingComponent={ Spinner }
      />
      <TrancheList tranches={ deal.tranches } />
      <DealDetails deal={ deal } showDealDetailsByDefault expandDirection="top" />
    </>
  );
};
